import { useParams, Navigate } from 'react-router-dom';

export const ClassRedirect = () => {
  const { classId } = useParams();
  return <Navigate to={`/app/students/${classId}`} replace />;
};
